const tenantErrorMessages = {
  TOO_WEAK: "Password is too weak.",
  EMAIL_ALREADY_EXISTS: "Email already exists.",
  UNKNOWN_EMAIL: "Unknown email.",
  INVALID_PASSWORD: "Password is invalid.",
  ALREADY_MEMBER: "User is already a member of this project."
};
const getTenantErrorMessage = (errorCode) => {
  if (errorCode in tenantErrorMessages) {
    return tenantErrorMessages[errorCode];
  }
  return `Unknown error occurred. [${errorCode}]`;
};
export {
  getTenantErrorMessage,
  tenantErrorMessages
};
//# sourceMappingURL=tenantErrorMessages.js.map
